import React from "react";

export default function AccessForbidden() {
    return (
      <div className="construct_block access_denied_block_img">
        <h3>Доступ запрещен</h3>
      </div>
        );
      }
